import React, { useCallback } from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import {
  useLoadBasedSubmissionDetection,
  useMessageBasedSubmissionDetection,
} from "./hooks";

function IFrameForm({
  formUrl,
  title,
  validator,
  onDismiss,
  dismissMessage,
  ...props
}) {
  useMessageBasedSubmissionDetection(
    validator,
    useCallback(onDismiss, [onDismiss])
  );
  const { updateLoadCount } = useLoadBasedSubmissionDetection(
    validator,
    useCallback(onDismiss, [onDismiss])
  );

  return (
    <div style={{ width: "100%", height: "calc(100vh - 47px)" }} {...props}>
      <div style={{ position: "absolute", right: "1em" }}>
        <Button
          data-test="dismiss-iframe-form-icon"
          circular={!dismissMessage}
          icon={dismissMessage ? undefined : "close"}
          content={dismissMessage}
          style={{
            marginTop: "1em",
            color: "white",
            backgroundColor: "#536dfe",
          }}
          onClick={onDismiss}
        />
      </div>
      <iframe
        id="iframe-form"
        onLoad={updateLoadCount}
        src={formUrl}
        title={title}
        style={{
          border: "none",
          display: "block",
          minHeight: "inherit",
        }}
      />
    </div>
  );
}

IFrameForm.propTypes = {
  formUrl: PropTypes.string.isRequired,
  title: PropTypes.string,
  onDismiss: PropTypes.func.isRequired,
  dismissMessage: PropTypes.string,
  validator: PropTypes.object,
};

IFrameForm.defaultProps = {
  title: "iFrame Form",
  dismissMessage: undefined,
  validator: undefined,
};

export default IFrameForm;
